import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/api";
import { useAuth } from "@/auth";
import { useLang } from "@/i18n";
import { BackHome } from "@/components/BackHome";

export default function Login() {
  const { setUser } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate(data.role === "coach" ? "/coach" : "/app");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative">
      <BackHome />
      <img
        src="https://images.unsplash.com/photo-1641337221253-fdc7237f6b61?crop=entropy&cs=srgb&fm=jpg&q=85"
        alt="" className="absolute inset-0 w-full h-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/40" />
      <div className="relative w-full max-w-md kc-card p-8" data-testid="login-card">
        <div className="flex justify-center mb-6">
          <img src="/adtraining-full-t.png" alt="AD TRAINING PROGRAM" className="h-44 w-auto kc-logo-ondark" />
          <img src="/adtraining-full-onlight.png" alt="AD TRAINING PROGRAM" className="h-44 w-auto kc-logo-onlight" />
        </div>
        <h1 className="text-3xl font-black uppercase tracking-tight mb-1">{t("login.title")}</h1>
        <p className="text-muted-foreground text-sm mb-6">{t("login.subtitle")}</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{t("login.email")}</label>
            <input data-testid="login-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="kc-input mt-1" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{t("login.password")}</label>
            <input data-testid="login-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} className="kc-input mt-1" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <button data-testid="login-submit-button" type="submit" disabled={loading} className="kc-btn-primary w-full">
            {loading ? t("common.loading") : t("login.submit")}
          </button>
        </form>
        <div className="mt-5 flex flex-col gap-2 text-sm">
          <Link data-testid="forgot-password-link" to="/forgot-password" className="text-muted-foreground hover:text-foreground">
            {t("login.forgot")}
          </Link>
          <Link data-testid="login-register-link" to="/register" className="text-muted-foreground hover:text-foreground">
            {t("reg.noAccount")}
          </Link>
          <Link to="/privacy" className="text-muted-foreground/60 hover:text-muted-foreground text-xs">Privacy</Link>
        </div>
      </div>
    </div>
  );
}
